import { makeStyles } from 'tss-react/mui';
import { ProductParcel } from '../adapters/product-types';
import { P2GCardContainer, P2GGrid, P2GIcon, P2GText, SvgClipboard, SvgParcel2 } from '@parcel2go/core-ui';
import React from 'react';

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: `${theme.shape.borderRadius * 2}px !important`,
    '& .MuiCardContent-root': {
      padding: theme.spacing(2) + '!important'
    }
  }
}));

type ProductItemParcelsProps = {
  parcels: ProductParcel[];
};

export function ProductItemParcels({ parcels }: ProductItemParcelsProps) {
  const { classes } = useStyles();

  return (
    <P2GCardContainer dataTestId="basket-item-parcels-container" classNames={[classes.root]}>
      <P2GGrid container gap={1} direction="column">
        {parcels.map((p, i) => {
          const allParcelDimsDefined = p.length && p.width && p.height;
          const pRef = p.references?.find((r) => r.type === 'ParcelNumber')?.reference;

          return (
            <React.Fragment key={p.contents + i}>
              {pRef && (
                <P2GGrid item>
                  <P2GText variant="subtitle2">{pRef}</P2GText>
                </P2GGrid>
              )}
              <P2GGrid item>
                <P2GGrid container gap={1} alignItems="center" direction="row" wrap="nowrap">
                  <P2GGrid item>
                    <P2GIcon size="xs" palette="primary">
                      <SvgClipboard />
                    </P2GIcon>
                  </P2GGrid>
                  <P2GGrid item>
                    <P2GText variant="body2" fontWeight="bold">
                      {p.contents}
                    </P2GText>
                  </P2GGrid>
                </P2GGrid>
              </P2GGrid>
              <P2GGrid item>
                <P2GGrid container gap={1} direction="row" wrap="nowrap">
                  <P2GGrid item>
                    <P2GIcon size="xs" palette="primary">
                      <SvgParcel2 />
                    </P2GIcon>
                  </P2GGrid>
                  <P2GGrid item>
                    <P2GGrid container flexDirection="column">
                      <P2GGrid item>
                        <P2GText variant="body2" display="flex" gap={1}>
                          {allParcelDimsDefined && (
                            <>
                              {p.length} x {p.width} x {p.height}cm
                              <span>|</span>
                            </>
                          )}
                          <P2GText variant="body2">{p.weight}kg</P2GText>
                        </P2GText>
                      </P2GGrid>
                    </P2GGrid>
                  </P2GGrid>
                </P2GGrid>
              </P2GGrid>
            </React.Fragment>
          );
        })}
      </P2GGrid>
    </P2GCardContainer>
  );
}
